import { render, staticRenderFns } from "./Recherche.vue?vue&type=template&id=28386ffc"
import script from "./Recherche.vue?vue&type=script&lang=js"
export * from "./Recherche.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports